<script>
    export let students = [];
</script>

<style>
    .students-container {
        font-size: 0.9rem;
        color: #333;
        margin-bottom: 0.8rem;
    }
    
    .students-label {
        font-weight: 600;
        margin-bottom: 0.3rem;
        color: #555;
    }
    
    .students-list {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
    }
    
    .student-item {
        background-color: #f8f9fa;
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        border: 1px solid #e9ecef;
        font-size: 0.85rem;
        display: flex;
        align-items: center;
        gap: 0.3rem;
    }
    
    .student-name {
        color: #333;
    }
    
    .student-grade {
        background-color: #fab45a;
        color: #000;
        padding: 0.1rem 0.4rem;
        border-radius: 3px;
        font-weight: 600;
        font-size: 0.75rem;
        min-width: 1.5rem;
        text-align: center;
    }
</style>

{#if students && students.length > 0}
    <div class="students-container">
        <div class="students-label">Mokiniai:</div>
        <div class="students-list">
            {#each students as student}
                <div class="student-item">
                    <span class="student-name">
                        {student.full_name || student.username}
                    </span>
                    {#if student.grade}
                        <span class="student-grade">
                            {student.grade === 'university' ? 'Univ' : student.grade}
                        </span>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
{/if}
